import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFork: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fork, caple,  food, restaurant"><path d="M5.75 2.75L4.75 15L8.75 19.1944V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10 13.0278V2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14 2.75V13.0278" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.25 2.75L19.25 15L15.25 19.1944V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFork;
